// - URL/endpoints - //

/** Base Url for the Valhalla's API */
const baseUrl = 'https://valhalla.api.powertrip.earth/';

/** Valhalla endpoint to get a route */
export const VALHALLA_ROUTE_ENDPOINT = baseUrl + 'route'

/** Valhalla endpoint to get an optimized route */
export const VALHALLA_OPTIMIZED_ROUTE_ENDPOINT = baseUrl + 'optimized_route'


// - config - //

/**
 * The maximum number of locations a valhalla route call can take at its worst costing type of auto.
 */
export const MAX_VALHALLA_LOCATIONS = 20